<template>
    <div class="card">
      <header>
        <img class="avatar" width="40" height="40" :alt="user.name" :src="ExternalFun.getImageUrl(user.imgId)" style="display: none;" />
        <p class="name">{{ user.name }}</p>
      </header>
      <footer>
        <input class="search" type="text" placeholder="search user..." @keyup="handleKeyup" />
      </footer>
    </div>
  </template>
  
 
  <script lang="ts" setup>
  import { useStore } from 'vuex';
  import { computed,onMounted } from 'vue';
  import { debounce } from 'lodash'; // 确保安装了 lodash
  import { ref } from 'vue';
  import { ExternalFun } from '../../ExternalFun';
  const imageUrl = ref(null);
  // 定义接口 (类型)
  interface User {
    name: string;
    imgId: number;
  }
  
  // 使用 Composition API
  const store = useStore();
  
  // 用户信息 (计算属性)
  const user = computed<User>(() => store.state.user);
  // 搜索函数 (防抖处理)
  const onKeyup = debounce((value: string) => {
    store.commit('SET_FILTER_KEY', value); // 触发 mutation
  }, 150); // 150ms 防抖延迟
  
  // 本地 onKeyup 函数，用于处理 input 事件
  const handleKeyup = (e: Event) => { // KeyboardEvent -> Event
    const target = e.target as HTMLInputElement;
    onKeyup(target.value); // 调用防抖函数
  };

  onMounted(async () => {
 
  })  

 

  </script> 
  
  
  <style scoped lang="less">
  .card {
    padding: 12px;
    border-bottom: solid 1px #24272C;
  
    footer {
      margin-top: 10px;
    }
  
    .avatar,
    .name {
      vertical-align: middle;
    }
  
    .avatar {
      border-radius: 2px;
    }
  
    .name {
      display: inline-block;
      margin: 0 0 0 15px;
      font-size: 16px;
    }
  
    .search {
      padding: 0 10px;
      width: 100%;
      font-size: 12px;
      color: #fff;
      height: 30px;
      line-height: 30px;
      border: solid 1px #3a3a3a;
      border-radius: 4px;
      outline: none;
      background-color: #26292E;
    }
  }
  </style>